﻿export enum TransformSpace {
  Global = 'global',
  Local = 'local'
}
